exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".new {\n  line-height: 111px;\n  margin-top: 12px;\n}\n.new .newCenter {\n  text-align: center;\n  cursor: pointer;\n  color: #ababab;\n  font-weight: 900;\n  font-size: 15px;\n}\n.partsCard {\n  margin-top: 12px;\n}\n.partsCard div {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n  display: block;\n  float: left;\n}\n.partsCard div p {\n  line-height: 33px;\n  color: #ababab;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 170px;\n}\n.partsCard div p:nth-child(1) {\n  color: black;\n  font-size: 18px;\n}\n.partsCard img {\n  display: block;\n  float: left;\n  width: 45px;\n  height: 45px;\n  border-radius: 100px;\n  margin-right: 16px;\n  margin-left: 16px;\n}\n.call {\n  margin-left: 10px;\n  display: block;\n  margin-top: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/parts/index.less
// module id = 1543
// module chunks = 0